/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ to: NonNullable<unknown>, from: NonNullable<unknown> }} Model_Downgraded_CapInputs */

const en_model_downgraded_cap = /** @type {(inputs: Model_Downgraded_CapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Premium credits are used up this month — this used ${i?.to} instead of ${i?.from}.`)
};

const id_model_downgraded_cap = /** @type {(inputs: Model_Downgraded_CapInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kredit premium bulan ini habis — hasil ini memakai ${i?.to}, bukan ${i?.from}.`)
};

/**
* | output |
* | --- |
* | "Premium credits are used up this month — this used {to} instead of {from}." |
*
* @param {Model_Downgraded_CapInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const model_downgraded_cap = /** @type {((inputs: Model_Downgraded_CapInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Model_Downgraded_CapInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_model_downgraded_cap(inputs)
	return en_model_downgraded_cap(inputs)
});